import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { HsnModel } from './hsn.model'
import { environment } from '../../../../environments/environment'
import { catchError, map, Observable } from 'rxjs'

const API_URL = environment.apiUrl
@Injectable({
  providedIn: 'root',
})
export class HsnService {
  constructor(private http: HttpClient) {}

  addHsn(hsn: HsnModel) {
    return this.http.post(API_URL + '/Hsn/CreateHsn', hsn, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  updateHsn(hsn: HsnModel) {
    
    return this.http.put(API_URL + '/Hsn/UpdateHsn', hsn, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  getAllHsn(): Observable<HsnModel[]> {
    return this.http.get(API_URL + '/Hsn/ReadHsn', {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  deleteHsn(hsn: HsnModel) {
    
    return this.http
      .delete(API_URL + '/Hsn/DeleteHsn', {
        headers: {},
        body: hsn,
        withCredentials: true
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }
}
